<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                    <h2 class="mb-4">Dead Leads</h2>
                    <div class="leads-btns">
                        <!-- <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'realEstate')">Real Estate
                            (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'finTech')">FinTech (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'propService')">Prop Services
                            (0)</button> -->
                            <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'realEstate',
                                'btn-outline-light': selectedServiceType !== 'realEstate'
                              }" (click)="selectService('realEstate')">
                        Real Estate
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'finTech',
                                'btn-outline-light': selectedServiceType !== 'finTech'
                              }" (click)="selectService('finTech')">
                        FinTech
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'propService',
                                'btn-outline-light': selectedServiceType !== 'propService'
                              }" (click)="selectService('propService')">
                        Prop Services
                    </button>

    
    
                    </div>
               

                <!-- Data Table -->
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                       
                                <th>S.No</th>
                                <th>Lead Id</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let leadRec of leads; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ leadRec?.leadId }}</td>
                                <td>{{leadRec?.customerName}}</td>
                                <td>{{ leadRec?.email }}</td>
                                <td>{{ leadRec?.mobile }}</td>
                                <td>{{leadRec?.createdAt }}</td>
                                <td>
                                    <!-- Add any action buttons here -->
                                    <button class="btn btn-sm btn-primary" (click)="view(leadRec)">View</button>
                                </td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </main>
    
    </div>
</div>